import {handleSsoRedirectRequest} from '@client/util/ssoRedirect';
import windowHelper from '@client/util/windowHelper';

export enum SsoRouteNames {
  SsoAuthCallbackPage = 'SsoAuthCallbackPage',
  CompleteSso = 'CompleteSso',
}

const redirectUrlList = new Set([
  process.env.VUE_APP_COGNITO_PRINCIPAL_SIMPLEINVEST_AUTH_URL,
  process.env.VUE_APP_COGNITO_AUTH0_SIMPLEINVEST_AUTH_URL,
]);

export default [
  {
    path: '/initiate-principal-sso',
    beforeEnter(to): void {
      handleSsoRedirectRequest(to.query);

      // changes for fortify vulnerabilities
      const redirectUrl = process.env.VUE_APP_COGNITO_PRINCIPAL_SIMPLEINVEST_AUTH_URL;

      if (redirectUrlList.has(redirectUrl)) windowHelper.location.replace([...redirectUrlList][0]);
    },
    meta: {
      publicRoute: true,
      isCognitoSso: true,
    },
  },
  {
    path: '/initiate-auth0-sso',
    beforeEnter(to): void {
      handleSsoRedirectRequest(to.query);

      // changes for fortify vulnerabilities
      const redirectUrl = process.env.VUE_APP_COGNITO_AUTH0_SIMPLEINVEST_AUTH_URL;

      if (redirectUrlList.has(redirectUrl)) windowHelper.location.replace([...redirectUrlList][1]);
    },
    meta: {
      publicRoute: true,
      isCognitoSso: true,
    },
  },
  {
    path: '/sso-callback/:provider',
    name: SsoRouteNames.SsoAuthCallbackPage,
    props: true,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/pages/sso/SsoAuthCallback.vue'),
    meta: {
      publicRoute: true,
      isCognitoSso: true,
    },
  },
  {
    path: '/complete-sso',
    name: SsoRouteNames.CompleteSso,
    props: true,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/pages/sso/CompleteSso.vue'),
    meta: {
      publicRoute: true,
      isCognitoSso: true,
    },
  },
];
